module.exports = __webpack_public_path__ + "i18n/pt-BR.e22088bd8389ed022605274dbc64409f.json";


//////////////////
// WEBPACK FOOTER
// ./~/file-loader?name=i18n/[name].[hash].[ext]!./i18n/pt-BR.json
// module id = 854
// module chunks = 60